export default __webpack_public_path__ + "static/media/1.ff5a8a0f.png";